<template>
    <div></div>
</template>
<script>
import { httpRequest } from '@/utils.js';

export default {
    created() {
        httpRequest('POST', '/sql', { sql: 'DELETE FROM games;' })
    }
}
</script>